var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0H2C.9 0 0 .9 0 2v19.4c0 .4.1.9.4 1.2l2 3.5.1.2c.4.4.9.7 1.5.7s1.1-.3 1.5-.7l2.1-3.6c.3-.4.4-.8.4-1.3V2c0-1.1-.9-2-2-2zM4 24.9L2 21h4l-2 3.9zM6 19H2V2h4v17z"}));
}

Pen.defaultProps = {"width":"8","height":"27","viewBox":"0 0 8 27"};

module.exports = Pen;

Pen.default = Pen;
